export default {
  TEACHER_APP: "teacherApp",
  PARENT_APP: "parentApp",
  STUDENT_APP: "studentApp",
};
